import { PageHeader } from 'antd'
import styled from 'styled-components'

export const CustomPageHeader = styled(PageHeader)`
  background: #fff !important;
  padding-bottom: 0 !important;
  padding-left: 0 !important;
  .ant-tabs-top > .ant-tabs-nav {
    margin: 0 !important;
    margin-top: -19px !important;
  }
  /* & .ant-page-header-content{
   padding-top:0 !important
  } */
  & .ant-tabs-tab-btn {
    font-size: 16px;
    font-weight: 600;
    line-height: 2.5;
    color: rgb(162, 162, 162);
  }
  & .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.primary_color};
    font-weight: 600;
  }
  & .ant-tabs-ink-bar {
    background: ${({ theme }) => theme.primary_color};
  }
  & .ant-tabs-top > .ant-tabs-nav::before {
    line-height: 46px;
    border: 0;
    border-bottom: 1px dotted #f0f0f0;
    /* border-bottom: 1px dotted lightgray; */
    box-shadow: none;
  }
`
